import { create } from 'zustand';

interface IPrintComponentRequestState {
  difficulty: string[];
  unanswered: boolean;
  rightAnswer: boolean;
  wrongAnswer: boolean;
  questionOptions: string[];
  favorites: boolean;
  exerciseTypes: string[];
  selectedYear: string[];
  institutionType: string[];
  setDifficulty: (difficulties: string[]) => void;
  setUnanswered: (option: boolean) => void;
  setRightAnswer: (option: boolean) => void;
  setWrongAnswer: (option: boolean) => void;
  setQuestionOptions: (types: string[]) => void;
  setFavorites: (favorite: boolean) => void;
  setExerciseTypes: (types: string[]) => void;
  setSelectedYear: (years: string[]) => void;
  setInstitutionType: (institutions: string[]) => void;
  resetExercisePrint: () => void;
}

export const usePrintComponentRequestStore =
  create<IPrintComponentRequestState>((set) => ({
    difficulty: [],
    unanswered: false,
    rightAnswer: false,
    wrongAnswer: false,
    questionOptions: [],
    favorites: false,
    exerciseTypes: [],
    selectedYear: [],
    institutionType: [],
    setExerciseTypes: (types: string[]) => set({ exerciseTypes: types }),
    setDifficulty: (difficulties: string[]) =>
      set({ difficulty: difficulties }),
    setUnanswered: (option: boolean) => set({ unanswered: option }),
    setRightAnswer: (option: boolean) => set({ rightAnswer: option }),
    setWrongAnswer: (option: boolean) => set({ wrongAnswer: option }),
    setQuestionOptions: (types: string[]) => set({ questionOptions: types }),
    setFavorites: (favorite: boolean) => set({ favorites: favorite }),
    setSelectedYear: (years: string[]) => set({ selectedYear: years }),
    setInstitutionType: (institutions: string[]) =>
      set({ institutionType: institutions }),
    resetExercisePrint: () =>
      set({
        difficulty: [],
        unanswered: false,
        rightAnswer: false,
        wrongAnswer: false,
        questionOptions: [],
        favorites: false,
        exerciseTypes: [],
        selectedYear: [],
        institutionType: [],
      }),
  }));
